import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  produtos: {
    fontSize: "36px",
    color: "#424242",
  },
  titloCard: {
    fontWeight: "bold",
  },
  actions: {
    textAlign: "left",
  },
  tituloProdutos: {
    borderBottom: "1px solid rgba(255,255,255,0.2)",
    paddingBottom: 16,
    marginBottom: 16,
    textAlign: "center",
  },
  produtoItem: {
    margin: "15px 25px",
    width: "calc(50% - 50px)",
    float: "left",
    textAlign: "center",
    cursor: "pointer",
  },
  produtoItemParagrafo: {
    fontSize: "12px",
    padding: "5px 0 0 0",
    width: "100px",
    margin: 0,
    fontWeight: 600,
    color: "white",
  },
});
